import React, { useEffect, useState } from 'react'
import YellowTag from '../../assets/images/png/yellow-tag-icon.svg'
import VendorImage from '../../assets/images/png/vendor-img.png'
import Email from '../../assets/images/png/email-icon.png'
import Like from '../../assets/images/png/vendor-like-icon.svg'
import Call from '../../assets/images/png/call-icon.svg'
import Share from '../../assets/images/png/vendor-share-icon.svg'
import farmingLoans from '../../assets/images/png/farmingLoans.png'
import LiICon from '../../assets/images/png/li-icon.svg'
import {
  EmailIcon,
  EmailShareButton,
  FacebookIcon,
  FacebookShareButton,
  TelegramIcon,
  TelegramShareButton,
  TwitterIcon,
  TwitterShareButton,
  WhatsappIcon,
  WhatsappShareButton
} from 'react-share'
import { Modal } from 'react-bootstrap'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { getInstructions } from '../../services/GetInstructionService'
import {
  addProductToCart,
  getProductsInCart
} from '../../services/CartServices'
import { ToastContainer, toast } from 'react-toastify'

const VendorInfo = details => {
  const [show, setShow] = useState(false)
  const [instruct, setInstruct] = useState([])
  const handleClose = () => setShow(false)
  const handleShow = () => setShow(true)
  const { id } = useParams()
  const token = localStorage.getItem('token')
  const navigate = useNavigate()
  const [productQuantity, setProductQuantity] = useState(1)

  const product = details?.details?.vendorData?.totalPosts.find(
    product => product._id === id
  )

  const shareUrl = `https://farmerscity.in/`
  const vendor = `Vendor: ${details?.details?.vendorData?.name}`
  const contact = `Contact: ${details?.details?.vendorData?.email}, ${details?.details?.vendorData?.mobile}`

  const sharedContent = `${vendor}\n${shareUrl}\n${contact}`

  const convertDate = x => {
    const d = new Date(x)
    const options = { month: 'long', day: 'numeric', year: 'numeric' }
    return d.toLocaleDateString('en-US', options)
  }

  const instructions = async () => {
    const response = await getInstructions()
    setInstruct(response)
  }

  useEffect(() => {
    instructions()
  }, [])
  console.log('instruct----->', instruct)

  const handleConnectClick = () => {
    const token = localStorage.getItem('token')
    if (!token) {
      navigate('/signin')
    } else {
      window.location.href = `tel:+${details?.details?.vendorData?.mobile}`
    }
  }

  const handleMailClick = () => {
    const token = localStorage.getItem('token')
    if (!token) {
      navigate('/signin')
    } else {
      window.location.href = `mailto:${details?.details?.vendorData?.email}`
    }
  }

  const updateQuantity = quantity => {
    if (quantity < 1) {
      quantity = 1
    }
    setProductQuantity(quantity)
  }

  const handleQuantityChange = e => {
    const quantity = parseInt(e.target.value)
    if (!isNaN(quantity)) {
      updateQuantity(quantity)
    }
  }

  return (
    <>
      <ToastContainer />
      <div>
        <div className='bg_dark_green d-none d-md-flex align-items-center justify-content-between p-4 rounded-3'>
          <div>
            <span className='text-white fw-bold ff_arial fs_4xl'>
              ₹{product?.price}
            </span>
            <span className='text-white fw-normal text-capitalize'>
              / {product?.priceType}
            </span>
          </div>
          <img width={25} src={YellowTag} alt='tag' />
        </div>
        <div className='mt-4'>
          <div className='bg-white p-4 rounded-2'>
            <h4 className='text-uppercase ff_heebo clr_dark_blue fs_md lh-26 fw-bold'>
              VENDOR INFO
            </h4>
            <div className='light-grey-hr-line w-100 position-relative '>
              <div className='green-hr-line green-hr-line-width'></div>
            </div>
            <div className='mt-3 text-center'>
              <div className='position-relative vendor-image-div'>
                <div className='online-dot position-absolute'></div>
                <img className='w-100' src={VendorImage} alt='VendorImage' />
              </div>
              <p className='text-capitalize my-2 fw-bold ff_heebo fs_lg'>
                {details?.details?.vendorData?.name}
              </p>
              <p className='text-capitalize text-grey fw-noraml fs_xsm ff_heebo'>
                joined:{' '}
                {convertDate(
                  details?.details?.productData?.vendorId?.createdAt
                )}
              </p>
            </div>
            <div className='d-flex align-items-center justify-content-center'>
              <div
                onClick={handleMailClick}
                className='icons-div d-flex align-items-center justify-content-center mx-2 cursor-pointer'
              >
                <img className='icons' src={Email} alt='email' />
              </div>

              <img className='mx-2' src={Like} alt='like' />
              <div
                onClick={handleConnectClick}
                className='icons-div d-flex align-items-center justify-content-center mx-2 cursor-pointer'
              >
                <img src={Call} alt='call' />
              </div>

              <img
                onClick={handleShow}
                className='mx-2 cursor-pointer'
                src={Share}
                alt='share'
              />
            </div>
            <hr className='my-2' />
            <div className='d-flex align-items-center justify-content-between'>
              <span className='fw-semibold text-black ff_heebo fs_xsm '>
                Total Post
              </span>
              <span className='fw-normal ff_heebo fs_xsm  text-dark-grey'>
                {details?.details?.vendorData?.totalPosts?.length}
              </span>
            </div>
            <hr className='my-2' />
            <div className='d-flex align-items-center justify-content-between'>
              <span className='fw-semibold text-black ff_heebo fs_xsm '>
                Total Ratings
              </span>
              <span className='fw-normal ff_heebo fs_xsm  text-dark-grey'>
                {details?.details?.vendorData?.totalRating}
              </span>
            </div>
            <hr className='my-2' />

            <button
              className='w-100 bg_dark_green py-2 mt-3 border-0 rounded-2 text-white fw-normal ff_heebo'
              onClick={handleConnectClick}
            >
              CONNECT NOW
            </button>
          </div>
        </div>
        <div className=' mt-4'>
          <div className='bg-white p-4 rounded-2'>
            <h4 className='text-uppercase ff_heebo clr_dark_blue fs_md lh-26 fw-bold'>
              Get Finance
            </h4>
            <div className='light-grey-hr-line w-100 position-relative '>
              <div className='green-hr-line green-hr-line-width'></div>
            </div>
            <Link to={'/get-finance'}>
              <img className='w-100 mt-3 rounded-2' src={farmingLoans} alt='' />
            </Link>
          </div>
        </div>
        <div className=' mt-4'>
          <div className='bg-white p-4 rounded-2'>
            <h4 className='text-uppercase ff_heebo clr_dark_blue fs_md lh-26 fw-bold'>
              Location
            </h4>
            <div className='light-grey-hr-line w-100 position-relative '>
              <div className='green-hr-line green-hr-line-width'></div>
            </div>
            <iframe
              className='w-100 mt-4'
              src='https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d15283601.145823602!2d72.11030417053153!3d20.73668711616692!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x30635ff06b92b791%3A0xd78c4fa1854213a6!2sIndia!5e0!3m2!1sen!2sin!4v1709029139988!5m2!1sen!2sin'
              height='300'
              loading='lazy'
              referrerpolicy='no-referrer-when-downgrade'
            ></iframe>
          </div>
        </div>
        <div className=' my-4'>
          <div className='bg-white p-4 rounded-2'>
            <h4 className='text-uppercase ff_heebo clr_dark_blue fs_md lh-26 fw-bold'>
              instructions
            </h4>
            <div className='light-grey-hr-line w-100 position-relative '>
              <div className='green-hr-line green-hr-line-width'></div>
            </div>
            {instruct?.map((value, index) => (
              <div key={index} className='mt-3'>
                <div className='d-flex mt-2 align-items-start'>
                  <img className='mt-1 me-1' src={LiICon} alt='icon' />
                  <p className='m-0 p-0 text-dark-grey fs_xsm fw-normal'>
                    {' '}
                    {value}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
        {show && (
          <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
              <Modal.Title>Share Vendor Information</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className='row'>
                <div className='col-sm-6 text-center'>
                  <img className='w-50' src={VendorImage} alt='productsImg' />
                </div>
                <div className='col-sm-6 mt-4 mt-sm-0'>
                  <div>
                    <h2 className='ff_heebo fs_xl clr_dark_blue fw-bold text-capitalize'>
                      {details?.details?.vendorData?.name}
                    </h2>
                    <div className='py-1 d-flex align-items-center gap-2'>
                      <p className='ff_heebo clr_dark_blue fs_xsm fw-medium mb-0'>
                        Joined:
                      </p>
                      <p className='ff_heebo clr_dark_grey_2 fs_xsm fw-medium mb-0'>
                        {convertDate(
                          details?.details?.productData?.vendorId?.createdAt
                        )}
                      </p>
                    </div>
                    <div className='py-1 d-flex align-items-center gap-2'>
                      <p className='ff_heebo clr_dark_blue fs_xsm fw-medium mb-0'>
                        Contact:
                      </p>
                      <div className='d-flex align-items-center gap-1'>
                        <a
                          href={`mailto:${details?.details?.vendorData?.email}`}
                        >
                          <div
                            className='icons-div d-flex align-items-center justify-content-center mx-2 cursor-pointer'
                            onClick={handleMailClick}
                          >
                            <img className='icons' src={Email} alt='email' />
                          </div>
                        </a>
                        <a
                          href={`tel:+${details?.details?.vendorData?.mobile}`}
                        >
                          <div
                            className='icons-div d-flex align-items-center justify-content-center mx-2 cursor-pointer'
                            onClick={handleConnectClick}
                          >
                            <img src={Call} alt='call' />
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer className=' justify-content-start'>
              <EmailShareButton url={sharedContent}>
                <EmailIcon size={36} />
              </EmailShareButton>
              <FacebookShareButton url={sharedContent}>
                <FacebookIcon size={36} />
              </FacebookShareButton>
              <WhatsappShareButton url={sharedContent}>
                <WhatsappIcon size={36} />
              </WhatsappShareButton>
              <TelegramShareButton url={sharedContent}>
                <TelegramIcon size={36} />
              </TelegramShareButton>
              <TwitterShareButton url={sharedContent}>
                <TwitterIcon size={36} />
              </TwitterShareButton>
            </Modal.Footer>
          </Modal>
        )}
      </div>
    </>
  )
}

export default VendorInfo
